import axios from 'axios'
import type { LoginFormUser } from '@/services/firebase/formDataHelpers'

const ENDPOINT_PREFIX = process.env.VUE_APP_ENDPOINT_PREFIX || '/'
const ENSURE_MEMBER_TIMEOUT_MS = 5000

export interface EnsureMemberPayload {
  uuid: string
  email: string
  app_flag: string
  site_flag: string
  device_flag: 'SP' | 'PC'
}

/** Firebase認証済みユーザーの孤児Member救済用JSON payloadを組み立てる。 */
export function buildEnsureMemberPayload(
  vueInstance: any,
  user: LoginFormUser
): EnsureMemberPayload {
  return {
    uuid: user.uid,
    email: user.email || '',
    app_flag: vueInstance.$site.appFlag,
    site_flag: 'r',
    device_flag: vueInstance.$deviceLib.isMobileDevice ? 'SP' : 'PC'
  }
}

/** 新規クライアント呼び出しはCLAUDE.mdの規約どおりJSONで送信する。 */
export async function ensureMember(
  payload: EnsureMemberPayload
): Promise<void> {
  await axios.post(`${ENDPOINT_PREFIX}auth/ensure_member/`, payload, {
    timeout: ENSURE_MEMBER_TIMEOUT_MS,
    headers: { 'Content-Type': 'application/json' }
  })
}
